import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FunctionsHelper } from 'src/app/helpers/functions';
import { AuthService } from 'src/app/shared/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  submitClicked: boolean = false;
  formSubmitted: boolean = false;
  error: string = '';

  passwordConfirming(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.parent?.get('password')?.value !== control.value) {
      return { invalid: true };
    }
    return null;
  }

  resetPasswordForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern(this._functionsHelper.regexPatterns.email)]),
    password: new FormControl('', [Validators.required]),
    confirm_password: new FormControl('', [Validators.required, this.passwordConfirming]),
  });

  get resetPasswordFormControl() {
    return this.resetPasswordForm.controls;
  }

  onSubmit() {
    this.submitClicked = true;
    this.error = '';

    if (this.resetPasswordForm.valid) {
      this.formSubmitted = true;

      this.authService
        .resetPassword(this.resetPasswordForm.value.email, this.resetPasswordForm.value.password)
        .then((user) => {
          if (user.result) {
            this.resetPasswordForm.reset();
            this.router.navigate(['login'], { state: { passwordReset: true } });
          }
        })
        .catch((error) => {
          this.error = error.message;
          this.formSubmitted = false;
        });
    }
  }

  constructor(private router: Router, private authService: AuthService, private _functionsHelper: FunctionsHelper) {}

  ngOnInit(): void {}
}
